
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Svhivaninagartomumbai() {



    const cardData =
    {
        keyword: ' Shivajinagar to Mumbai Cab ',
        heading: 'Skyline Cabs: Shivajinagar to Mumbai Cab',
        headingDescription: 'Skyline Cabs provides dependable and comfortable Shivajinagar to Mumbai Cab services. Whether you are planning a business visit, leisure trip, or airport transfer, our clean, well-maintained vehicles and courteous drivers ensure a smooth and timely journey. With affordable pricing, prompt pickups, and a strong focus on customer satisfaction, Skyline Cabs makes your travel from Shivajinagar to Mumbai stress-free and convenient. Book your cab today for a reliable travel experience.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Shivaji Nagar to Mumbai Innova Crysta",
      "description": "Travel from Shivaji Nagar to Mumbai in comfort and style with Skyline Cabs' Innova Crysta. Enjoy spacious seating, smooth rides, and on-time service."
    },
    {
      "name": "Pune Station to Mumbai Cab Service",
      "description": "Book a cab from Pune Station to Mumbai with Skyline Cabs for reliable intercity travel. Choose from Ertiga, Innova Crysta, and Sedans for a hassle-free ride."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Skyline Cabs offers affordable round-trip cab services between Pune and Mumbai. Ideal for business meetings or family visits with professional drivers and quality vehicles."
    },
    {
      "name": "Bund Garden to Mumbai Cab",
      "description": "Skyline Cabs offers timely and comfortable taxi service from Bund Garden to Mumbai. Our fleet includes Ertiga, Innova Crysta, and more."
    },
    {
      "name": "Yerwada to Mumbai Cab Service",
      "description": "Get reliable and efficient cab service from Yerwada to Mumbai with Skyline Cabs. On-time pickups and courteous drivers make your ride pleasant."
    },
    {
      "name": "Camp to Mumbai Cab Service",
      "description": "Book a cab from Camp, Pune to Mumbai with Skyline Cabs. Choose from multiple cab options including Innova Crysta and Ertiga for a stress-free journey."
    },
    {
      "name": "Wakdewadi to Mumbai Cab",
      "description": "Skyline Cabs offers dependable cab service from Wakdewadi to Mumbai. Enjoy smooth rides in clean, well-maintained vehicles driven by professionals."
    },
    {
      "name": "Khadki to Mumbai Cab Service",
      "description": "Travel from Khadki to Mumbai with Skyline Cabs. Affordable pricing and flexible vehicle options make us a preferred choice for intercity travel."
    },
    {
      "name": "Swargate to Mumbai Cabs",
      "description": "Book your Mumbai trip from Swargate with Skyline Cabs. Our punctual service and clean cars ensure a smooth ride to your destination."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Skyline Cabs provides Ertiga cab service from Pune to Mumbai. Perfect for family travel with comfort and luggage space at budget-friendly rates."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in luxury from Pune to Mumbai with Skyline’s Innova cab. Spacious, comfortable, and perfect for business or family travel."
    },
    {
      "name": "Cab Service in Shivaji Nagar Pune",
      "description": "Skyline Cabs provides local and intercity cab services in Shivaji Nagar, Pune. Enjoy professional service and clean vehicles for your every ride."
    },
    {
      "name": "Shivaji Nagar to Dadar Cab Service",
      "description": "Travel from Shivaji Nagar to Dadar with Skyline Cabs for a smooth and comfortable ride. Choose from a fleet of Ertiga, Innova, and Sedans."
    },
    {
      "name": "Shivaji Nagar to Andheri Cab Service",
      "description": "Skyline Cabs offers timely taxi services from Shivaji Nagar to Andheri. Travel with experienced drivers and a comfortable fleet of vehicles."
    },
    {
      "name": "Pune Station to Mumbai Cab",
      "description": "Skyline Cabs provides convenient and affordable cab service from Pune Station to Mumbai. Choose the vehicle that suits your travel needs best."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Skyline Cabs is your trusted choice for Pune to Mumbai travel. We offer quality service, clean vehicles, and transparent pricing for your intercity journey."
    },
    {
      "name": "Innova Crysta on Rent in Shivaji Nagar Pune",
      "description": "Rent an Innova Crysta in Shivaji Nagar from Skyline Cabs for luxury travel. Ideal for family trips, business travel, and comfortable city rides."
    },
    {
      "name": "Ertiga on Rent in Shivaji Nagar",
      "description": "Skyline Cabs offers Ertiga rentals in Shivaji Nagar. Enjoy budget-friendly, spacious rides for local travel or long-distance journeys to Mumbai."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs is a reliable taxi provider offering quality cab services across Pune and Mumbai. Travel with peace of mind in clean and spacious vehicles."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs provides city-wide taxi service in Pune. From Shivaji Nagar to Swargate, we offer timely pickups and a range of vehicle choices."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Get safe and timely airport transfer from Pune to Mumbai with Skyline Cabs. Vehicles include Innova, Ertiga, and Sedans with skilled drivers."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs offers top-notch cab services between Pune and Mumbai. Ideal for airport drops, business trips, or leisure travel."
    },
    {
      "name": "Cab Service in Shivaji Nagar Pune",
      "description": "Need a cab in Shivaji Nagar? Skyline Cabs offers local and long-distance cab services with professional drivers and affordable fares."
    },
    {
      "name": "Cab Service in Shivaji Nagar Station",
      "description": "Skyline Cabs offers pickup from Shivaji Nagar Station for Mumbai-bound cabs. Get a comfortable and punctual ride to your destination."
    }
  ],
  "tableData": [
    ["Shivaji Nagar to Mumbai Innova Crysta", "Pune Station to Mumbai Cab Service"],
    ["Pune to Mumbai Cab Round Trip", "Bund Garden to Mumbai Cab"],
    ["Yerwada to Mumbai Cab Service", "Camp to Mumbai Cab Service"],
    ["Wakdewadi to Mumbai Cab", "Khadki to Mumbai Cab Service"],
    ["Swargate to Mumbai Cabs", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Cab Service in Shivaji Nagar Pune"],
    ["Shivaji Nagar to Dadar Cab Service", "Shivaji Nagar to Andheri Cab Service"],
    ["Pune Station to Mumbai Cab", "Best Cab Service Pune to Mumbai"],
    ["Innova Crysta on Rent in Shivaji Nagar Pune", "Ertiga on Rent in Shivaji Nagar"],
    ["Skyline Cabs Pune", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
    ["Cab Service in Shivaji Nagar Pune", "Cab Service in Shivaji Nagar Station"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Shivajinagar to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides dependable and on-time cab services from Shivajinagar to Mumbai, making sure you never miss a meeting, flight, or family event. Our commitment to punctuality and professional service sets us apart for all your intercity travel needs."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles",
        "WhyChoosedescription": "Enjoy your journey in clean, well-maintained, and air-conditioned cabs. From solo rides to group travel, our sedans, SUVs, and luxury cars offer a comfortable and spacious experience for your Shivajinagar to Mumbai trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers Who Know the Route",
        "WhyChoosedescription": "Our drivers are professionally trained and familiar with the Shivajinagar to Mumbai route. They know how to navigate through traffic efficiently while ensuring your ride is smooth, safe, and pleasant from pickup to drop-off."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fares",
        "WhyChoosedescription": "We believe in fair and transparent pricing. Skyline Cabs offers competitive fares for Shivajinagar to Mumbai cabs with no hidden charges, so you always know exactly what you’re paying for—no surprises at the end of your ride."
    },
    {
        "WhyChooseheading": "24/7 Availability from Shivajinagar",
        "WhyChoosedescription": "Need a cab early in the morning or late at night? Skyline Cabs operates 24/7, so you can book a ride from Shivajinagar to Mumbai whenever you need it. Our always-on service ensures we’re ready whenever you are."
    },
    {
        "WhyChooseheading": "Flexible Vehicle Options to Match Your Needs",
        "WhyChoosedescription": "Choose from a wide variety of vehicles depending on your travel preferences and budget. Whether you want a budget-friendly sedan, a spacious SUV, or a premium car, we’ve got the right vehicle for your journey from Shivajinagar to Mumbai."
    },
    {
        "WhyChooseheading": "Quick and Easy Booking Process",
        "WhyChoosedescription": "With Skyline Cabs, booking a cab from Shivajinagar to Mumbai is quick, easy, and stress-free. Use our website or mobile app to book in just a few steps, get instant confirmation, and track your cab with real-time updates."
    },
    {
        "WhyChooseheading": "Safe and Secure Rides with Verified Drivers",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are GPS-enabled for live tracking, and all drivers go through rigorous background checks. Enjoy peace of mind knowing you're in safe hands for your Shivajinagar to Mumbai ride."
    }
]














    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Shivajinagar to Mumbai with Skyline Cabs?',
            answer:
                'Booking is quick and easy with Skyline Cabs. You can reserve your cab online via our website or app, or call our customer support. Just select Shivajinagar as your pickup point and Mumbai as your destination.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for the Shivajinagar to Mumbai route?',
            answer:
                'We provide a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether it’s a solo trip or a family journey, we have a car to match your needs and comfort.',
        },
        {
            id: 3,
            question: 'Is the fare from Shivajinagar to Mumbai fixed?',
            answer:
                'Yes, our fares are fixed and all-inclusive. You’ll see the total fare at the time of booking, which includes tolls, taxes, and driver charges — no hidden costs.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round trip from Shivajinagar to Mumbai?',
            answer:
                'Absolutely! We offer both one-way and round-trip cab options. Just choose what suits you best during the booking process.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Shivajinagar to Mumbai?',
            answer:
                'The journey takes around 3 to 3.5 hours depending on traffic and weather. Our drivers are well-versed with the route and ensure a timely and safe ride.',
        },
        {
            id: 6,
            question: 'Are your drivers professional and experienced?',
            answer:
                'Yes, all our drivers are background-verified, experienced, and trained for long-distance travel. Your safety and comfort are our top priorities.',
        },
        {
            id: 7,
            question: 'Can I pre-schedule a Shivajinagar to Mumbai cab?',
            answer:
                'Yes, we recommend pre-booking your ride via our app or website, especially during peak hours or weekends, to ensure timely availability.',
        },
        {
            id: 8,
            question: 'Do you offer airport drop service from Shivajinagar to Mumbai?',
            answer:
                'Yes, we offer direct drop-offs to both Mumbai Domestic and International Airports from Shivajinagar. Just provide your flight details during booking.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my ride after booking?',
            answer:
                'Definitely. We have a flexible cancellation and modification policy, and you can manage your ride easily via our app or with the help of our customer support.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for Shivajinagar to Mumbai travel?',
            answer:
                'Skyline Cabs stands out for reliable service, transparent pricing, and comfortable vehicles. We ensure a smooth journey with trained drivers and customer-first support.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Deshpande",
            rating: 5,
            review: "I booked a cab from Shivajinagar to Mumbai for a business trip. The car was neat, the driver was punctual and polite, and the ride was absolutely hassle-free. Highly recommend Skyline Cabs!"
        },
        {
            name: "Miss. Aarti Patankar",
            rating: 4,
            review: "The ride was smooth and timely. I really appreciated the driver’s courteous behavior and knowledge of the route. It would be great to have phone charging ports in the car for added convenience."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shivajinagar to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/shivajinagar-to-mumbai-cab.jpg",
  "description": "Book Shivajinagar to Mumbai cab service with Skyline Cabs for fast, affordable, and safe travel. Choose from AC sedans, SUVs, and premium cars with 24/7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7549"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/shivajinagar-to-mumbai-cab-service"
  }
};



      
     


    return (
        <div>

<Helmet>
  <title>Shivajinagar to Mumbai Cab Service | One-Way & Round Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Shivajinagar to Mumbai cab service with Skyline Cabs for fast, affordable, and safe travel. Choose from AC sedans, SUVs, and premium cars with 24/7 availability and professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Shivajinagar to Mumbai Cab Service, Cab from Shivajinagar to Mumbai, One-Way Taxi Shivajinagar to Mumbai, Round Trip Cab Shivajinagar to Mumbai, AC Cab Shivajinagar to Mumbai, SUV Taxi Shivajinagar to Mumbai, Skyline Cabs Shivajinagar to Mumbai, Affordable Cab Service Shivajinagar to Mumbai, Online Cab Booking Shivajinagar Mumbai, 24/7 Cab Shivajinagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Svhivaninagartomumbai;